import { cloneElement, FC, isValidElement, PropsWithChildren, useEffect } from 'react';
import { RouteChildrenProps } from 'react-router-dom';
import { WixConnection } from './components/wix-connection';
import { SiteSessionWrapper } from './modules/sites/site-session-wrapper';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import { Bootstrap } from 'src/redesign/app';
import { MainLayout } from 'src/redesign/layouts';
import { usePostHog } from 'posthog-js/react';
import { isEmpty } from 'lodash';
import { Header } from 'src/redesign/features/Header';
import { Tabs } from 'src/redesign/features/Tabs';
import { AuthRouter } from 'src/features/AuthRouter';
import { PublicRouter } from 'src/features/PublicRouter';
import styles from './App.module.scss';
import './styles.scss';
import { useAppSelector } from 'src/hooks';
import { accountSelector } from 'src/redesign/features/Account/store/selectors';
import { Modals } from 'src/redesign/features/Modals';
import { globalReloadingSelectors } from 'src/redesign/shared/store/selectors';
import { Loader } from 'wix-style-react';
import Intercom from '@intercom/messenger-js-sdk';
import { ToastNotifications } from 'src/redesign/features/Toast';

export const isPublicRoute = () => {
  const path = window.location.href;
  return (
    path.includes('/auth/') ||
    path.includes('/new-event/') ||
    path.includes('/email-verification') ||
    path.includes('/self-checkin') ||
    path.includes('/order-frame')
  );
};
export const App = () => {
  const account = useAppSelector(accountSelector);
  const posthog = usePostHog();
  const globalReloading = useAppSelector(globalReloadingSelectors);

  useEffect(() => {
    const path = window.location.href;
    if (!path.includes('/new-event/') || !path.includes('/self-checkin')) {
      const intercomConfig: Record<string, any> = {
        app_id: 'm51ut11q',
      };

      if (!isEmpty(account)) {
        intercomConfig.user_id = account.id;
        intercomConfig.name = account.first_name
          ? `${account.first_name} ${account.last_name}`
          : account.email;
        intercomConfig.email = account.email;
        intercomConfig.created_at = account.created_at;
        intercomConfig.user_hash = account.intercom_hash;

        posthog?.identify(account.email, {
          email: account.email,
        });
      }

      Intercom(intercomConfig);
    }
  }, [account, posthog]);

  if (
    process.env.NODE_ENV === 'production' &&
    window.brand === 'wix' &&
    !account?.has_app_updated
  ) {
    return <WixConnection />;
  }

  return (
    <Bootstrap>
      {account && !isPublicRoute() ? (
        <>
          <Header />
          <Tabs />
          <MainLayout>{globalReloading ? <Loader size="small" /> : <AuthRouter />}</MainLayout>
          <Modals />
          <ToastNotifications />
        </>
      ) : (
        <div className={styles.publicPageWrapper}>
          <PublicRouter />
          <ToastNotifications />
        </div>
      )}
    </Bootstrap>
  );

  // return (
  //   <div className="App">
  //     {window.brand === 'wix' && account.newsletter_opt_in === null && (
  //       <NewsletterOptIn account={account} />
  //     )}
  //     {/* {account.display_review_offer === null && <LeaveReview account={account} />} */}

  //   </div>
  // );
};

export const SiteWrapper: FC<PropsWithChildren<RouteChildrenProps & { noAuth?: boolean }>> = (
  props,
) => {
  const { children, match, noAuth } = props;
  const params = match.params as { site_id?: string };
  return (
    <SiteSessionWrapper siteId={params?.site_id} noAuth={noAuth}>
      {isValidElement(children) && cloneElement(children, { ...props })}
    </SiteSessionWrapper>
  );
};
